/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CrossOwnerDocsCheckDmvsPendingPozadavkyCreateRequest = {} | null | undefined;
export type CrossOwnerDocsCheckDmvsPendingPozadavkyCreateResponse = any;

export type CrossOwnerDocsCheckDmvsPendingPozadavkyCreateQuery = {};

/**
 * POST /dmx-server/cross_owner_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: cross_owner_docs_check_dmvs_pending_pozadavky_create
 * description: Finalizuje odmítnutí až po úspěchu všech DMVS notifikací.
 * tags:
 *   - cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossOwnerDocsCheckDmvsPendingPozadavkyCreateOperation = (
  rest?: CrossOwnerDocsCheckDmvsPendingPozadavkyCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/cross_owner_docs/check_dmvs_pending_pozadavky/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cross_owner_docs/check_dmvs_pending_pozadavky/' };
  };

/**
 * POST /dmx-server/cross_owner_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: cross_owner_docs_check_dmvs_pending_pozadavky_create
 * description: Finalizuje odmítnutí až po úspěchu všech DMVS notifikací.
 * tags:
 *   - cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossOwnerDocsCheckDmvsPendingPozadavkyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: CrossOwnerDocsCheckDmvsPendingPozadavkyCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = crossOwnerDocsCheckDmvsPendingPozadavkyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
